<div class="program_builder_page">
    <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
    <app-header [headerTitle]="headerTitle"></app-header>

    <mdb-tabs>
        <mdb-tab title="Programs">
            <div class="create_container">
                <button class="createBtn" (click)="createProgram()">Create+</button>
            </div>
            <div *ngFor="let cat of categories; let catIndex = index">
                <ng-container>

                    <div class="heading" [ngClass]="{'target_grey': !cat.visible}">
                        {{cat.name}}
                    </div>

                    <div class="myPrograms">
                        <div class="programs_opacity"></div>
                        <div style="margin-bottom: 27px; z-index: 100;">
                            <div class="carousell">

                                <ng-container *ngIf="cat?.programs?.length; else noPrograms">
                                    <div class="card_container" *ngFor="let program of cat.programs| sortName:'name'; let catProgramIndex = index">
                                        <div class="image_div"><img #cardElement
                                            id="cardElement" class="card_image" [ngStyle]="{ height: calculateCardHeight() + 'px' }" [src]="program?.programImage" alt="">
                                        </div>
                                        <div class="card_content_container">
                                            <div class="card_content_row">
                                                <div class="inprogress" style="background-color: #C9C8F6 !important;" *ngIf="!program.publishedAt || isEditedAfterPublication(program)">
													Draft
												</div>
												<div class="inprogress" *ngIf="program.publishedAt && !isEditedAfterPublication(program)">
													Published
												</div>

                                                <div class="icons">
                                                    <mat-icon  (click)="editProgramNewBuilder(program, catIndex, catProgramIndex)" style="font-size: 18px !important;
                                                    font-family: Material Icons !important;
                                                    line-height: 23px;
                                                    width: 20px !important;
                                                    height: 20px !important;">edit</mat-icon>
                                                    <!-- </button> -->
                                                    <div (click)="changeState(program)" class="full_screen_icon"><img
                                                            src="../../assets/images/outline.svg" alt="">
                                                    </div>
                                                </div>

                                            </div>

                                            <h2 class="hire_inspire">{{program.name}}</h2>
                                            <p class="card_para_container">
                                                {{program.description}}
                                            </p>

                                            <!-- <div class="complete progress" style="height: 10px">

                                            </div> -->

                                            <div class="card_footer">

                                                <!-- <div class="date-box">
                                                    <p *ngIf="(!program.publishedAt || isEditedAfterPublication(program)) && (program.updatedAt)">Last Edit Date:<br>{{ program.updatedAtDate | date: 'shortDate' }}</p>
                                                    <p *ngIf="program.publishedAt && !isEditedAfterPublication(program)">Last Publish Date:<br>{{ program.publishedAt.toDate() | date: 'shortDate' }}</p>
                                                </div> -->

                                                <div class="date-box">
                                                    <p *ngIf="(!program.publishedAt || isEditedAfterPublication(program)) && program.updatedAt">
                                                        Last Edit Date:<br>{{ program.localizedDate | date: 'shortDate' }}
                                                    </p>
                                                    <p *ngIf="program.publishedAt && !isEditedAfterPublication(program)">
                                                        Last Publish Date:<br>{{ program.localizedDate | date: 'shortDate' }}
                                                    </p>
                                                </div>

                                                <!-- <div style="    margin-right: 3px;
                                                " class="footer_column">
                                                    <div class="card_footerIcn">
                                                        <img src="../../assets/images/Time Circle.svg" alt="">
                                                    </div>
                                                    <div class="card_footer_sub_head">
                                                        {{program.courseTime}}
                                                    </div>
                                                </div> -->

                                                <!-- <div class="footer_column">
                                                    <div class="card_footerIcn">
                                                        <img src="../../assets/images/Category.svg" alt="">
                                                    </div>
                                                    <div class="card_footer_sub_head">
                                                        {{program.numberOfSections}}
                                                    </div>
                                                </div> -->

                                                <!-- <div>
                                                    <button class="rem_btn" mat-button (click)="editProgram(program)"
                                                        style="margin-bottom: 10px">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div> -->


                                                <div class="footer_column">
                                                    <div class="launchBtn" (click)="launchProgram(program)">
                                                        Launch <img
                                                            src="../../assets/images/Arrow - Right.svg" alt="">
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #noPrograms>
                                    <div>No programs have been created in this category.</div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        </mdb-tab>

        <mdb-tab title="Categories">
            <div class="con">
                <div class="create_container">
                    <button class="createBtn" (click)="createCategory()">Add Category+</button>
                </div>
                <!-- <div class="create_container">
                    <button class="createBtn" (click)="createCategory()">Create+</button>
                </div> -->
                <div class="categ_container" *ngFor="let cat of categories">
                    <div class="categName">{{cat.name}} <div><button mat-button
                                (click)="createCategory(cat)">Edit</button></div>
                    </div>
                    <ng-container *ngIf="cat?.subCategories?.length">
                        <ul class="subCateg" *ngFor="let subCat of cat.subCategories">
                            <li> {{subCat.name}} </li>
                        </ul>
                    </ng-container>

                </div>
            </div>

        </mdb-tab>
    </mdb-tabs>
</div>

<div class="left-stuff" [@widthGrow]="state" *ngIf="programDetails">
    <div class="card_details_container">
        <div (click)="changeState('cross')" class="cross_btn"><img src="../../assets/images/crossbtn.svg" alt=""></div>

        <div class="card_details">
            <div class="card_details_image"><img [src]="programDetails?.landscapeImage ? programDetails?.landscapeImage : programDetails?.programImage" alt="Program Landscape Image"></div>
            <div class="card_container">
                <div class="card_c_row">
					<div class="inprogress" style="background-color: #C9C8F6 !important;" *ngIf="!programDetails.publishedAt || isEditedAfterPublication(programDetails)">
						Draft
					</div>
					<div class="inprogress" *ngIf="programDetails.publishedAt && !isEditedAfterPublication(programDetails)">
						Published
					</div>

                    <!-- <div class="pt">10pt</div> -->
                    <div class="hrs_section">
                        <!-- <span class="hours"><img src="../../assets/images/Time Circle.svg" alt="">
                            {{ getLearningHrs(programSections) }} Hours</span>  -->
                        <span class="hours"><img src="../../assets/images/Time Circle.svg" alt="">
                            {{ programDetails.courseTime }} </span>
                            <!-- <span class="section"><img
                                src="../../assets/images/Category.svg" alt=""> {{ getSectionNos(programSections) }}
                            Sections</span> -->
                            <span class="section"><img
                                src="../../assets/images/Category.svg" alt=""> {{ programDetails.numberOfSections }}
                                {{
                                    programDetails.numberOfSections >= 2 ? 'Sections' :
                                    'Section' }}</span>
                        </div>
                </div>
                <h2 class="hire_inspire">{{programDetails.name}}</h2>
                <p class="inspector-tagline" style="white-space: pre-line;">{{programDetails.tagline}}</p>
                <p class="inspector-des" style="white-space: pre-line;">{{programDetails.description}}</p>
            </div>
            <div class="complete_launch_container">
                <div class="complete progress" style="height: 10px">
                    <div class="complete_text">Complete {{ programDetails.progress ? programDetails.progress : 0 }}%</div>
                    <div role="progressbar" class="progress-bar"
                        style.width="{{ programDetails.progress ? programDetails.progress : 0 }}%" aria-valuenow="10"
                        aria-valuemin="0" aria-valuemax="100">
                    </div>
                </div>
                <div class="launchBtn" (click)="launchProgram(programDetails)">
                    Launch <img style="width: 18px;height: 18px;" src="../../assets/images/Arrow - Right.svg" alt="Launch Button Image">
                </div>


            </div>

            <div class="section_details_container">
                <div class="section_detail_row" *ngFor="let section of programDetails?.sections">
                    <div class="sec_name_no">
                        <div class="section_name">{{ section.name }}</div> | <div class="total_units">{{
                            section.numberOfUnits ? section.numberOfUnits: 0 }}

                            {{
                            section.numberOfUnits >= 2 ? 'units' :
                            'unit' }}

                        </div>
                    </div>
                    <div class="section_desc" style="white-space: pre-line;">{{ section.description }}</div>
                </div>
            </div>
        </div>

    </div>
</div>